export enum AlertType {
  Info = 'info',
  Warn = 'warn',
  Error = 'error',
}

export interface AlertCssProps {
  type?: AlertType;
}
